module.exports = __webpack_public_path__ + "img/keeper_of_the_light.02c4bbff.png";